import React, { useEffect, useState } from "react";
import { useTeamManagementCabotageStore } from "../../../store/TeamManagementStore";
import { TeamManagementService } from "../../../core/_request";
import { HttpStatusCode } from "axios";
import { CustomButton } from "../../../../../common/components/CustomButton/CustomButton";
import { Assets } from "../../../../../assets";
import { LFTableV3 } from "../../../../../common/components/LFTable/LFTableV3";
import {
  generateColorArray,
  getNumberOfALetter,
} from "../../../../../utilities/random_color";
import { Avatar, Tooltip } from "antd";
import { getFirstCharOfAstring } from "../../../../../utilities/string";
import { ActionsKey } from "../../../../../common/models/Actions";
import { Loader } from "../../../../../common/components/Loader/Loader";
import { ColumnItem } from "../../../../../common/models/table";
import CustomModal from "../../../../../common/components/Modal/CustomModal";
import { CreateTeamForm } from "../../createTeam/CreateTeamForm";
import { useSearchParams } from "react-router";

const COLORS = generateColorArray(50);

const cols: ColumnItem[] = [
  {
    key: "team",
    title: "Equipe",
    dataIndex: "name",
    show: true,
  },
  {
    key: "teamHandlingTechnicians",
    title: "Technicien de manuntention",
    dataIndex: "teamHandlingTechnicians",
    show: true,
    isCanSort: true,
    render: renderAvatarGroup,
  },
  {
    key: "teamCorporals",
    title: "Caporal",
    dataIndex: "teamCorporals",
    show: true,
    isCanSort: true,
    render: renderAvatarGroup,
  },
  {
    key: "teamPointers",
    title: "Pointeur / Litigeur",
    dataIndex: "teamPointers",
    show: true,
    isCanSort: true,
    render: renderAvatarGroup,
  },
  // {
  //   key: "teamLitigators",
  //   title: "Litigeur",
  //   dataIndex: "teamLitigators",
  //   show: true,
  //   isCanSort: true,
  //   render: renderAvatarGroup,
  // },
  {
    key: "teamCraneOperators",
    title: "Grutier",
    dataIndex: "teamCraneOperators",
    show: true,
    isCanSort: true,
    render: renderAvatarGroup,
  },
  {
    key: "teamDockers",
    title: "Docker",
    dataIndex: "teamDockers",
    show: true,
    isCanSort: true,
    render: renderAvatarGroup,
  },
  {
    key: "teamInTrainings",
    title: "En Formation",
    dataIndex: "teamInTrainings",
    show: true,
    isCanSort: true,
    render: renderAvatarGroup,
  },
  {
    key: "teamDailies",
    title: "Docker journalier",
    dataIndex: "teamDailies",
    show: true,
    isCanSort: true,
    render: renderAvatarGroup,
  },
];

function renderAvatarGroup(state: any) {
  return (
    <div className="h-100 w-100 d-flex align-items-center justify-content-center">
      <Avatar.Group>
        {state?.map((staffItem: any, key: number) => (
          <Tooltip title={staffItem?.fullname} placement="top" key={key}>
            <Avatar
              style={{
                backgroundColor:
                  COLORS[
                    getNumberOfALetter(
                      getFirstCharOfAstring(staffItem?.fullname)
                    )
                  ],
              }}
            >
              {getFirstCharOfAstring(staffItem?.fullname)}
            </Avatar>
          </Tooltip>
        ))}
      </Avatar.Group>
    </div>
  );
}

export const CabotageList = () => {
  const [searchParams] = useSearchParams();

  const {
    actioned,
    setActioned,
    setTeamManagementList,
    teamManagementList,
    pageState,
    setPageState,
    totalItems,
    resetPageState,
  } = useTeamManagementCabotageStore();

  const [isShowCreateModal, setIsShowCreateModal] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [teamManagementType, setTeamManagementType] = useState<any>("");

  useEffect(() => {
    const newParams = new URLSearchParams(searchParams);
    setTeamManagementType(newParams.get("movment") as string);
  }, [searchParams]);

  useEffect(() => {
    fetchAllTeams(pageState);
  }, [pageState]);

  const handleShowModal = () => {
    if (isShowCreateModal) {
      setActioned({ data: null, action: "no" });
    }
    setIsShowCreateModal((prev) => !prev);
  };

  const fetchAllTeams = async (params?: any) => {
    try {
      setIsLoading(true);
      const res = await TeamManagementService.getAllTeamsCabotage({
        ...pageState,
        ...params,
      });
      if (res?.status === HttpStatusCode.Ok) {
        setTeamManagementList(res?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const onActionClick = (item: any, action: ActionsKey) => {
    if (action === "delete") {
      onDeleteHandler(item?.id);
    } else {
      getOneTeam(item?.id, action);
    }
  };

  const onDeleteHandler = async (id: number) => {
    try {
      setIsLoading(true);
      const res = await TeamManagementService.deleteTeam(id);
      if (res?.status === HttpStatusCode.NoContent) {
        fetchAllTeams();
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const getOneTeam = async (id: number, action: any) => {
    try {
      setIsLoading(true);
      const res = await TeamManagementService.getTeamById(id);
      if (res?.status === HttpStatusCode.Ok) {
        setActioned({
          data: {
            ...res?.data,
            operationCategory: res?.data?.operationCategory?.["@id"],
          },
          action,
        });
      }
      handleShowModal();
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSetParams = (params: any) => {
    setPageState({
      ...pageState,
      ...params,
    });
  };

  return (
    <div>
      <Loader isLoading={isLoading} />

      <div className="d-flex gap-2 align-items-center mb-4">
        <div className="d-flex gap-2 align-items-center">
          <span className="fw-semibold fs-6">{`Equipe Cabotage`}</span>
        </div>

        <CustomButton
          className="d-flex align-items-center gap-2"
          onClick={handleShowModal}
        >
          <div className="">
            <img src={Assets.iconsSvg.addBox} />
          </div>
          {`Nouvelle équipe`}
        </CustomButton>
      </div>

      <LFTableV3
        columns={cols}
        params={pageState}
        data={teamManagementList}
        onAction={onActionClick}
        isCanDelete={() => true}
        isCanEdit={() => true}
        onSearch={handleSetParams}
        onSort={handleSetParams}
        onResetSearch={resetPageState}
        onChangePage={handleSetParams}
        pagination={{
          defaultCurrentPage: pageState.page,
          itemsPerPage: pageState?.itemsPerPage,
          totalItems: totalItems,
        }}
      />

      {isShowCreateModal && (
        <CustomModal
          isOpen={isShowCreateModal}
          hanldeCloseModal={handleShowModal}
          isShowCloseIcon={false}
          width={800}
        >
          <CreateTeamForm
            onClose={handleShowModal}
            type={teamManagementType}
            onSuccess={() => fetchAllTeams()}
            {...(actioned?.action === "update"
              ? {
                  initialValue: actioned?.data,
                }
              : {})}
          />
        </CustomModal>
      )}
    </div>
  );
};
